export default __webpack_public_path__ + "img/TourIntroImage-4396fd48cc9461e6c92b76d13b5e6520.png";